<template>
  <section class="column is-2">
    <p class="menu-label is-hidden-touch has-text-white">設定メニュー</p>
    <ul class="menu-list">
      <li>
        <a href="/#/settings/urgency" :class="{ 'is-active': 'urgency' === indexRoutePath($route.path, 2) }">
          <span class="icon"><i class="fa fa-cogs"></i></span> 緊急性設定
        </a>
      </li>
      <li>
        <a href="/#/settings/location" :class="{ 'is-active': 'location' === indexRoutePath($route.path, 2) }">
          <span class="icon"><i class="fa fa-cogs"></i></span> マップ初期値設定
        </a>
      </li>
      <template v-if="modules.module_location">
        <li v-if="user.permission.admin">
          <a href="/#/settings/device" :class="{ 'is-active': 'device' === indexRoutePath($route.path, 2) }">
            <span class="icon"><i class="fa fa-cogs"></i></span> GPS端末設定
          </a>
        </li>
      </template>
      <li v-if="user.permission.admin">
        <a href="/#/settings/members" :class="{ 'is-active': 'members' === indexRoutePath($route.path, 2) || 'mypage' === indexRoutePath($route.path, 2) }">
          <span class="icon"><i class="fa fa-cogs"></i></span> ユーザー情報設定
        </a>
      </li>
      <li v-else>
        <a :href="'/#/settings/mypage/'+user.id" :class="{ 'is-active': 'mypage' === indexRoutePath($route.path, 2) }">
          <span class="icon"><i class="fa fa-cogs"></i></span> マイページ
        </a>
      </li>
      <template v-if="modules.module_mode">
        <li v-if="user.permission.admin">
          <a href="/#/settings/mode" :class="{ 'is-active': 'mode' === indexRoutePath($route.path, 2) }">
            <span class="icon"><i class="fa fa-exclamation-triangle"></i></span> モード設定
          </a>
        </li>
      </template>
      <li v-if="user.permission.super_user">
        <a href="/#/settings/modules" :class="{ 'is-active': 'modules' === indexRoutePath($route.path, 2) || 'modules' === indexRoutePath($route.path, 2) }">
          <span class="icon"><i class="fa fa-cogs"></i></span> 使用モジュール設定
        </a>
      </li>
    </ul>
  </section>
</template>

<script>
import { mapState } from 'vuex'
export default {
  computed:{
    ...mapState({
      user: state => state.auth.user,
      modules: state => state.auth.modules,
      apiStatus: state => state.task.apiStatus,
    }),
  },
  methods:{
    indexRoutePath(strPath, index=0) {
      const path = strPath.split('/')
      return path[index]
    },
  }
}
</script>